import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ErrorScreen } from '@datapad/common-controls';
import { fail } from '@datapad/utilities';
import { Box } from '@mui/material';
import { MissingCampaign } from '../Constants.js';
import { CampaignView } from './CampaignView.js';
import { Toolbar } from './Toolbar.js';
export function CampaignsView(props) {
    const { campaigns, selection: selectedCampaign, changeSelection: changeCampaignSelection, addCampaign, deleteCampaign, } = props;
    let innerView;
    if (selectedCampaign === MissingCampaign) {
        innerView = _jsx(MissingCampaignErrorScreen, {});
    }
    else if (campaigns.length === 0) {
        innerView = _jsx(NoCampaignsErrorScreen, {});
    }
    else {
        const selectedCampaignOrDefault = selectedCampaign ?? campaigns[0] ?? fail('Failed to get member of non-empty array.');
        innerView = (_jsx(CampaignView, { campaign: selectedCampaignOrDefault, deleteCampaign: () => deleteCampaign(selectedCampaignOrDefault) }));
    }
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            width: '100%',
        }, children: [_jsx(Toolbar, { campaigns: campaigns, selection: selectedCampaign === MissingCampaign ? undefined : selectedCampaign, changeSelection: (newSelectedCampaign) => changeCampaignSelection(newSelectedCampaign), addCampaign: addCampaign }), _jsx(Box, { children: innerView })] }));
}
export function NoCampaignsErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            'No campaigns found.',
            'This is very unlikely and probably indicates an error.',
        ] }));
}
export function MissingCampaignErrorScreen() {
    return (_jsx(ErrorScreen, { textLines: [
            `The selected campaign does not exist.`,
            'This could indicate an error, or could indicate that the selected campaign has been deleted.',
        ] }));
}
//# sourceMappingURL=CampaignsView.js.map